import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=089cef5d&scoped=true"
import script from "./Battle.vue?vue&type=script&lang=js"
export * from "./Battle.vue?vue&type=script&lang=js"
import style0 from "./Battle.vue?vue&type=style&index=0&id=089cef5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089cef5d",
  null
  
)

export default component.exports